import { useQuery } from "@tanstack/react-query";
import { imagineStore } from "@/stores/imagine.store";
import type { GetSiteInfoResponseBody } from "@imagine/ai-service/shared-types/route-types";
import { aiServiceFetch } from "@/lib/ai-service-client";
import { HttpError } from "@/lib/http-error";

export function useSiteInfo() {
  const projectId = imagineStore.use.projectId();
  const isReadonly = imagineStore.use.isReadonly();

  return useQuery<GetSiteInfoResponseBody>({
    queryKey: ["site-info", projectId],
    queryFn: async () => {
      if (!projectId) {
        throw new Error("Missing project context");
      }

      const response = await aiServiceFetch(
        `/api/projects/${projectId}/site-info`,
        {
          method: "GET",
        },
      );

      if (!response.ok) {
        throw await HttpError.fromResponse(response);
      }

      return response.json();
    },
    enabled: !!projectId && !isReadonly,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchInterval: false,
  });
}
